import { dayjs } from "@equidefi/i18n";

export const PAYMENT_STATUS_DISPLAY = {
  created: {
    title: "Payment Pending",
    description: (payment) =>
      payment.payment_type === "wire" || payment.payment_type === "check"
        ? `You indicated you would pay by ${payment.payment_type}. Selecting a different payment method will cancel this payment.`
        : `You indicated you would pay by ${payment.payment_type}. Your payment will be pending until the funds are received by the issuer.`,
    color: "orange",
    status: "warning",
  },
  processing: {
    title: "Payment Processing",
    description: () => "Your payment is processing!",
    color: "blue",
    status: "info",
  },
  payment_failed: {
    title: "Payment Failed",
    description: (payment) => payment?.error_msg || "Your payment has failed",
    color: "red",
    status: "error",
  },
  requires_payment_method: {
    color: "red",
    title: "Payment Failed",
    description: (payment) => payment?.error_msg || "Your payment did not include a payment method",
    status: "error",
  },
  requires_action: {
    color: "orange",
    title: "Requires Action",
    description: () => "Your payment requires action",
    status: "warning",
  },
  succeeded: {
    title: "Payment Successful",
    description: () => "Your payment was received successfully!",
    color: "green",
    status: "success",
  },
  refunded: {
    title: "Payment Refunded",
    description: () => "Your payment has been refunded by the issuer.",
    color: "red",
    status: "error",
  },
  canceled: {
    title: (payment) =>
      payment?.category === "MANUAL" || payment?.category === "CRYPTO"
        ? "Payment Cancelled"
        : "Authorization Cancelled",
    description: (payment) =>
      payment?.error_msg ||
      (payment?.category === "MANUAL" || payment?.category === "CRYPTO"
        ? "Your payment has been canceled."
        : "The authorization placed on your card has cancelled."),
    color: "red",
    status: "error",
  },
  requires_capture: {
    title: "Payment Authorized",
    description: (payment) =>
      `Your card will be charged once your investment is approved. Authorization expires in ${dayjs(
        payment?.expiration_date,
      ).diff(payment?.create_date, "days")} days.`,
    color: "blue",
    status: "info",
  },
  expired: {
    title: "Authorization Expired",
    description: (payment) =>
      payment?.error_msg || "The authorization placed on your card has expired. Please retry your payment.",
    color: "red",
    status: "error",
  },
  underpaid: {
    title: "Underpaid",
    description: () => "Paid amount is lower than amount indicated on the investment.",
    color: "red",
    status: "error",
  },
};
